export class GruppeTierEinstalldatum {
    einstalldatum: Date;
    anzahl: number;
}
